/** @format */

import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  inject,
} from '@angular/core';

@Component({
  selector: `homefield-button, a[homefield-button], button[homefield-button]`,
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomefieldButtonComponent {
  private readonly ButtonVariants = {
    primary: 'homefield-button-primary',
    secondary: 'homefield-button-secondary',
    tertiary: 'homefield-button-tertiary',
    marketing: 'homefield-button-marketing',
  };

  private readonly ButtonHeights = {
    small: 'small-height',
    base: 'base-height',
    medium: 'medium-height',
    large: 'large-height',
  };

  @Input() variant: string = this.ButtonVariants.primary;
  @Input() height: string = this.ButtonHeights.base;
  @HostBinding('attr.aria-label') @Input() ariaLabel = '';
  @HostBinding('attr.data-test-id') @Input() dataTestId = '';
  @HostBinding('attr.data-em') @Input() dataEm = '';
  @HostBinding('class') @Input() classList = '';
  private readonly el = inject(ElementRef);

  @HostBinding('class') get getVariantApplication() {
    return `${this.classList}${this.classList ? ' ' : ''}${this.getAdditionalCssClass(this.variant, this.height)}`;
  }

  @HostListener('click', ['$event.currentTarget'])
  @HostListener('contextmenu', ['$event.currentTarget'])
  ignoreMouse(elementRef: EventTarget | null) {
    if (elementRef instanceof HTMLElement) {
      elementRef.blur();
    }
  }

  getAdditionalCssClass(variant: string, height: string) {
    const variantClass = this.ButtonVariants[variant as keyof typeof this.ButtonVariants] ?? '';
    const heightClass = this.ButtonHeights[height as keyof typeof this.ButtonHeights] ?? '';
    return `homefield-button hmf-label-m ${variantClass} ${heightClass}`;
  }

  hostClick(): void {
    this.el.nativeElement.click();
  }
}
